import { render, staticRenderFns } from "./KeyPal2Introduce.vue?vue&type=template&id=962ff072&scoped=true&"
import script from "./KeyPal2Introduce.vue?vue&type=script&lang=js&"
export * from "./KeyPal2Introduce.vue?vue&type=script&lang=js&"
import style0 from "./KeyPal2Introduce.vue?vue&type=style&index=0&id=962ff072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962ff072",
  null
  
)

export default component.exports